import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner } from "@coreui/react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { ReactNode, createContext, useCallback, useContext, useState } from "react";
import theme from "../assets/theme";
import { BorderColor } from "@mui/icons-material";


const style = {
  position: 'absolute',
  top: '30%',
  left: '50%',
//  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor:'primary.main',
  boxShadow: 24,
  p: 0,
};
export type t_btnVarinat ="text" | "contained" | "outlined";
export type t_btnColor = "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
export type T_alertButton = {
  text: string;
  color?: t_btnColor;
  variant?:t_btnVarinat;
  onPress?: () => void;
};

export type T_alert = {
  title?: string;
  msg: string;
  onHide?: () => void;
  buttonList?: T_alertButton[];
  visible : boolean;
};

export type T_setAlert = (alert:T_alert) => void;

export const initialAlert: T_alert = {
  msg: "",
  visible : false,
};


const AlertContext = createContext(initialAlert);


export function useAlert() {
  const Context: any = useContext(AlertContext);
  const alert: T_alert = Context.alert;
  const setAlert: T_setAlert = Context.setAlert;
  const result = { alert, setAlert };
  return result;
}

export function AlertContextProvider({children}: { children: ReactNode }){
    const [alert, setAlert] = useState(false);
    const value : any  = {
      alert,
      setAlert,
    }
  return (
    <AlertContext.Provider value={value}>
      {children}
    </AlertContext.Provider>
  );
}

export function GlobalAlert() {
    const {alert,setAlert } = useAlert();
  
    const hide = useCallback(() => {
      if (alert.onHide) {
        alert.onHide();
      }
      setAlert(initialAlert);
    }, [alert, setAlert]);

    
    return (
    <Modal
      open={alert.visible}
      onClose={() => setAlert({...alert,visible:false})}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    > 
    <Box sx={style}>
     <Box  sx={{w:'100%',height:45, bgcolor: 'primary.main',justifyItems:'center',justifyContent:'center',alignItems:'center',alignContent:'center'}}>
     <Typography variant="h6" color="#fff" noWrap component="div" sx={{ p:0 ,textAlign:'center'}}>
     {alert.title!= undefined ?alert.title:"확인"}
    </Typography>
     </Box>
    <Typography id="modal-modal-description" sx={{ m: 2 }}>
    {alert.msg}
    </Typography>
    <Box    sx={{
    display: 'flex',
    justifyContent: 'center',
    gap: 1,           // MUI spacing 단위: 2 → 16px
    flexWrap: 'wrap', // 버튼 개수가 많을 때 줄바꿈도 가능
    pb:1
  }}>
         {alert.buttonList?.map((item,idx)=>{
             return(
               <Button color={item.color} variant={item.variant} key={idx}  onClick={item.onPress}>{item.text}</Button>
             )
           })}
          {alert.buttonList == null?<Button onClick={hide}>예</Button>:""}
    </Box>
  </Box>
    </Modal>


      // <CModal
      // visible={alert.visible}
      // onClose={() => setAlert({...alert,visible:false})}
      // aria-labelledby="LiveDemoExampleLabel"
      // >
      // <CModalHeader  color="info" style={{background:"#4287f5",color:"#fffffff"}} >
      //    <div><CModalTitle style={{color:"#ffffff"}} id="LiveDemoExampleLabel"><div>{alert.title}</div></CModalTitle></div>
      // </CModalHeader>
      // <CModalBody>
      //     <p>{alert.msg}</p>
      // </CModalBody>
      // <CModalFooter>
      //     {alert.buttonList?.map((item,idx)=>{
      //       return(
      //         <Button key={idx}  onClick={item.onPress}>{item.text}</Button>
      //       )
      //     })}
      //     {alert.buttonList == null?<Button onClick={hide}>예</Button>:""}
      // </CModalFooter>
      // </CModal>
        );
  }